/** Tooltip surface for info-icon hover popovers (light + dark). */
export const ICON_HOVER_TEXT_TOOLTIP_SURFACE_CLASS = [
  'rounded-lg border shadow-lg font-light text-sm',
  'bg-gray-900 text-white border-gray-600',
  'dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600 dark:shadow-black/40',
].join(' ');

/** Default tones for child elements using the global `.info-icon` class. */
export const ICON_HOVER_TEXT_TRIGGER_ICON_CLASS = [
  '[&_.info-icon]:text-gray-400 [&_.info-icon]:hover:text-gray-800',
  'dark:[&_.info-icon]:text-gray-500 dark:[&_.info-icon]:hover:text-gray-200',
].join(' ');
